import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Box } from "@mui/material";
import { Controller } from "react-hook-form";
import themeNutriFast from '../styles/NutriFastColors';

export const FormInputRadio = ({ name, control, buttons, label, rules }) => {
  const generateButtons = (buttons) => {
    return buttons.map((button) => {
      return (
        <FormControlLabel
          key={'radio' + button.value}
          value={button.value}
          control={
            <Radio
              sx={{
                display: 'none'
              }}
            />
          }
          label=""
          sx={{
            margin: 0,
            '& .MuiButtonBase-root': {
              display: 'none'
            }
          }}
        />
      );
    });
  };

  const generateModernButtons = (buttons, fieldValue, onChange) => {
    return buttons.map((button, index) => {
      const isChecked = fieldValue === button.value;

      return (
        <Box
          key={'modern-radio-' + button.value + '-' + index}
          component="label"
          htmlFor={`${name}-${button.value}-${index}`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            cursor: 'pointer',
            padding: '14px 16px',
            borderRadius: '4px',
            border: '1px solid #e0e0e0',
            backgroundColor: '#fafafa',
            borderColor: '#e0e0e0',
            transition: 'all 0.2s ease',
            minWidth: '120px',
            position: 'relative',
            '&:hover': {
              borderColor: '#d0d0d0',
              backgroundColor: '#f5f5f5'
            }
          }}
        >
          <Box
            sx={{
              width: '16px',
              height: '16px',
              borderRadius: '50%',
              border: `1px solid ${isChecked ? '#666' : '#ccc'}`,
              position: 'relative',
              backgroundColor: isChecked ? '#666' : 'white',
              transition: 'all 0.2s ease',
              ...(isChecked && {
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '6px',
                  height: '6px',
                  borderRadius: '50%',
                  backgroundColor: 'white'
                }
              })
            }}
          />
          <Box
            component="span"
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#666',
              userSelect: 'none'
            }}
          >
            {button.label}
          </Box>
          <input
            type="radio"
            id={`${name}-${button.value}-${index}`}
            name={name}
            value={button.value}
            checked={isChecked}
            onChange={() => onChange(button.value)}
            style={{
              position: 'absolute',
              opacity: 0,
              width: '100%',
              height: '100%',
              margin: 0,
              cursor: 'pointer'
            }}
          />
        </Box>
      );
    });
  };

  return (
    <Controller
      render={({ field }) => (
        <FormControl
          sx={{
            width: '100%',
            my: { xs: 3, md: 1.5 }
          }}
          required={false}
        >
          <FormLabel
            sx={{
              fontSize: '14px',
              fontWeight: 400,
              color: '#666',
              marginBottom: 1.5,
              textAlign: 'left',
              alignSelf: 'flex-start',
              '&.Mui-focused': {
                color: '#666',
              }
            }}
          >
            {label}
          </FormLabel>

          <Box
            sx={{
              display: 'flex',
              gap: 2,
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'center'
            }}
          >
            {generateModernButtons(buttons, field.value, field.onChange)}
          </Box>

          {/* Radio group caché pour maintenir la compatibilité */}
          <RadioGroup
            aria-labelledby={'label_' + name}
            row
            {...field}
            sx={{ display: 'none' }}
          >
            {generateButtons(buttons)}
          </RadioGroup>
        </FormControl>
      )}
      name={name}
      control={control}
      rules={rules}
    />
  );
};